/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_List_No_UsersInputs */



/**
* | output |
* | --- |
* | "No users found" |
*
* @param {User_List_No_UsersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_no_users = /** @type {((inputs?: User_List_No_UsersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_No_UsersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun utilisateur trouvé")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron usuarios")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum usuário encontrado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun utente trovato")
	return /** @type {LocalizedString} */ ("No users found")
});